/** Phase 8 (Finanzen und Analysen) — Panel-Texte, Deutsch. Wird in `admin.de.ts` eingebunden (ADR-801); Begriffe: docs/I18N_GLOSSARY.md. */
export const adminFaz8De = {
  reports: {
    navGroup: 'Berichte und Einkauf',
    period: 'Zeitraum',
    presets: {
      this_month: 'Dieser Monat',
      last_month: 'Letzter Monat',
      last_7: 'Letzte 7 Tage',
      last_30: 'Letzte 30 Tage',
      last_90: 'Letzte 90 Tage',
      this_year: 'Dieses Jahr',
      last_year: 'Letztes Jahr',
      custom: 'Eigener Zeitraum',
    },
    from: 'Von',
    to: 'Bis',
    interval: 'Gruppierung',
    intervals: { day: 'Tag', week: 'Woche', month: 'Monat', year: 'Jahr' },
    all: 'Alle',
    csv: 'CSV herunterladen',
    xlsx: 'Excel herunterladen',
    print: 'Drucken / PDF',
    printedAt: 'Gedruckt: {{date}}',
    vsNamed: '{{name}}: {{value}}',
    vsPrevious: 'Vorzeitraum: {{value}}',
    deltaUp: '{{pct}} % mehr',
    deltaDown: '{{pct}} % weniger',
    deltaFlat: 'Keine Veränderung',
    deltaNew: 'Im Vorzeitraum nicht vorhanden',
    partial: 'Der Zeitraum ist noch nicht abgeschlossen; die heutigen Zahlen können sich noch ändern.',
    currencyNote:
      'Beträge in TRY. Bestellungen in Fremdwährung werden zum TCMB-Devisenankaufskurs zum Bestellzeitpunkt umgerechnet; Rücksendungen und Stornierungen zählen im Zeitraum der Bestellung.',
    empty: 'Keine Daten für diesen Zeitraum.',
    none: 'Nicht zugeordnet',
    loadingAgain: 'Wird aktualisiert…',
    chartEmpty: 'Keine Umsätze für das Diagramm.',
    tooltip: '{{bucket}}: {{value}}',
    dashboard: {
      noPermission: 'Für Umsatzzahlen ist die Berechtigung „Umsatzberichte“ erforderlich.',
      tilesLabel: 'Umsatzübersicht',
      today: 'Nettoumsatz heute',
      todayOrders: 'Bestellungen heute',
      yesterday: 'Gestern',
      last30: 'Nettoumsatz, letzte 30 Tage',
      last30Orders: 'Bestellungen, letzte 30 Tage',
      chartTitle: 'Letzte 30 Tage: täglicher Nettoumsatz (inkl. MwSt.)',
      open: 'Umsatzbericht öffnen',
    },
    share: 'Anteil',
  },
  salesReport: {
    tilesTitle: 'Zusammenfassung des Zeitraums',
    navLabel: 'Umsatzbericht',
    store: 'Shop',
    channel: 'Kanal',
    segment: 'Kundentyp',
    channels: { web: 'Onlineshop', b2b: 'Händlerportal', manual: 'Bestellung in der Verwaltung', api: 'API' },
    segments: { retail: 'Endkunde', dealer: 'Händler' },
    tiles: {
      netSales: 'Nettoumsatz',
      orders: 'Bestellungen',
      averageOrder: 'Durchschnittlicher Warenkorb',
      deductions: 'Rücksendungen und Stornierungen',
      newCustomers: 'Neue Kunden',
    },
    chartTitle: 'Nettoumsatz (inkl. MwSt.)',
    summaryTitle: 'Von brutto zu netto',
    rows: {
      productGross: 'Bruttoproduktumsatz (vor Rabatten)',
      discounts: 'Rabatte',
      shipping: 'Versand- und Nachnahmegebühren',
      orderTotal: 'Bestellwert',
      cancellations: 'Stornierter Betrag',
      refunds: 'Erstatteter Betrag',
      deductions: 'Rücksendungen und Stornierungen',
      netSales: 'Nettoumsatz (inkl. MwSt.)',
      tax: 'MwSt.',
      netSalesExVat: 'Nettoumsatz (ohne MwSt.)',
      itemsSold: 'Verkaufte Artikel',
      cancelledOrders: 'Vollständig stornierte Bestellungen',
      customers: 'Bestellende Kunden',
      returningCustomers: 'Wiederkehrende Kunden',
      newCustomerNetSales: 'Nettoumsatz mit neuen Kunden',
      returningCustomerNetSales: 'Nettoumsatz mit wiederkehrenden Kunden',
    },
    thisPeriod: 'Dieser Zeitraum',
    previousPeriod: 'Vorzeitraum',
    deductionNote:
      'Rücksendungen und Stornierungen sind der größere Wert aus storniertem und erstattetem Betrag: Eine bezahlte Bestellung muss vor der Stornierung erstattet werden, daher werden beide nicht addiert.',
    seriesTitle: 'Periodentabelle',
    columns: {
      bucket: 'Periodenbeginn',
      orders: 'Bestellungen',
      orderTotal: 'Bestellwert',
      deductions: 'Rücksendungen & Stornierungen',
      netSales: 'Nettoumsatz',
      netSalesExVat: 'Ohne MwSt.',
      averageOrder: 'Durchschnittlicher Warenkorb',
      name: 'Name',
      quantity: 'Menge',
    },
    total: 'Gesamt',
    awaiting: '{{count}} Bestellungen ({{amount}}) warten auf Zahlung; sie zählen nach Zahlungseingang.',
    fxMissing: 'Für {{count}} Bestellungen in Fremdwährung fehlt ein Wechselkurs; sie sind nicht enthalten.',
    breakdownTitle: 'Aufschlüsselung',
    breakdown: 'Aufschlüsseln nach',
    breakdowns: {
      product: 'Produkt',
      variant: 'Variante (SKU)',
      category: 'Kategorie',
      brand: 'Marke',
      country: 'Land',
      channel: 'Kanal',
      store: 'Shop',
      segment: 'Kundentyp',
      paymentMethod: 'Zahlungsart',
    },
    categoryNote:
      'Ein Produkt in mehreren Kategorien zählt in jeder; Kategoriesummen können die Gesamtsumme übersteigen. Der Anteil bezieht sich auf die Gesamtsumme.',
    lineNote:
      'Produktzahlen verwenden Positionsbeträge inkl. MwSt., abzüglich stornierter Einheiten und anteilig um die Erstattungen der Bestellung gemindert; Versand ist nicht enthalten.',
    showing: '{{shown}} von {{total}} Zeilen werden angezeigt; die Datei enthält alle.',
  },
  financeInputs: {
    navLabel: 'Finanzeingaben',
    section: 'Bereich',
    sections: {
      fees: 'Zahlungsgebühren',
      shipments: 'Versandkosten',
      shippingRules: 'Versandkosten-Schätzungen',
      expenses: 'Betriebsausgaben',
    },
    readOnly:
      'Sie können diese Zahlen ansehen; zum Ändern ist die Berechtigung „Finanzeingaben verwalten“ erforderlich.',
    providers: {
      iyzico: 'iyzico (Karte)',
      paytr: 'PayTR (Karte)',
      bank_transfer: 'Banküberweisung',
      cash_on_delivery: 'Nachnahme',
      open_account: 'Offenes Konto',
      manual: 'Manuell (Überweisung/Bar usw.)',
    },
    provider: 'Zahlungsart',
    installments: 'Raten',
    allInstallments: 'Alle übrigen Raten',
    installmentN: '{{n}} Raten',
    singlePayment: 'Einmalzahlung',
    rate: 'Satz (%)',
    fixedFee: 'Fixgebühr pro Transaktion',
    validFrom: 'Gültig ab',
    validTo: 'Gültig bis',
    openEnded: 'Unbefristet',
    note: 'Notiz',
    addFeeRule: 'Gebührenregel hinzufügen',
    editFeeRule: 'Gebührenregel bearbeiten',
    saveFeeRule: 'Regel speichern',
    feeRuleSaved: 'Gebührenregel gespeichert.',
    feeRuleDeleted: 'Gebührenregel gelöscht.',
    confirmDeleteFee: 'Diese Gebührenregel löschen? Die berechneten Gebühren im Finanzbericht ändern sich.',
    emptyFees: 'Keine Gebührenregeln',
    emptyFeesLead:
      'Geben Sie die Sätze aus Ihrem Vertrag mit dem Zahlungsanbieter ein. Bis dahin erscheinen Gebühren im Finanzbericht als „keine Daten“.',
    rateInvalid: 'Geben Sie einen Satz zwischen 0 und 50 ein (z. B. 2,49).',
    amountInvalid: 'Geben Sie einen Betrag ein (z. B. 125,50).',
    filter: 'Anzeigen',
    filters: { all: 'Alle Sendungen', missing: 'Kosten nicht erfasst', entered: 'Kosten erfasst' },
    carrier: 'Versanddienstleister',
    allCarriers: 'Alle Versanddienstleister',
    shipmentsSummary:
      '{{shipments}} Sendungen · erfasst (inkl. MwSt.): {{entered}} ({{enteredCount}} Sendungen) · geschätzt (ohne MwSt.): {{estimated}} · unbekannt: {{unknown}}',
    columns: {
      date: 'Datum',
      order: 'Bestellung',
      carrier: 'Versanddienstleister',
      tracking: 'Sendungsnummer',
      weight: 'Gewicht',
      cost: 'Kosten',
      source: 'Quelle',
      provider: 'Zahlungsart',
      installments: 'Raten',
      rate: 'Satz',
      fixedFee: 'Fixgebühr',
      validity: 'Gültigkeit',
      maxWeight: 'Höchstgewicht',
      category: 'Kategorie',
      description: 'Beschreibung',
      amount: 'Betrag (inkl. MwSt.)',
      vat: 'MwSt.',
      reference: 'Belegnummer',
      store: 'Shop',
    },
    estimated: 'geschätzt, ohne MwSt.',
    unknownCost: 'unbekannt',
    sources: { manual: 'Manuell', import: 'Datei' },
    enterCost: 'Kosten erfassen',
    editCost: 'Versandkosten bearbeiten',
    newCost: 'Versandkosten: {{tracking}}',
    amount: 'Betrag (inkl. MwSt.)',
    vat: 'MwSt.-Betrag',
    reference: 'Rechnungs- / Belegnummer',
    entryDate: 'Belegdatum',
    saveCost: 'Kosten speichern',
    costSaved: 'Versandkosten gespeichert.',
    costDeleted: 'Versandkosten gelöscht.',
    confirmDeleteCost: 'Die Versandkosten dieser Sendung löschen?',
    emptyShipments: 'Keine Sendungen in diesem Zeitraum',
    import: 'Rechnung des Versanddienstleisters hochladen',
    importTitle: 'Rechnungsdatei des Versanddienstleisters',
    importLead:
      'CSV oder Excel: Die Spalten „Takip no“ (Sendungsnummer) und „Tutar“ (Betrag) sind Pflicht; „KDV“, „Fatura no“ und „Tarih“ sind optional. Zuerst erscheint eine Vorschau; die Kosten werden nach Ihrer Bestätigung gespeichert.',
    file: 'Datei',
    preview: 'Vorschau',
    apply: 'Zugeordnete Zeilen speichern',
    overwrite: 'Vorhandene Kosten durch die Beträge aus der Datei ersetzen',
    importSummary:
      '{{ready}} Zeilen bereit · {{exists}} Sendungen haben bereits Kosten · {{errors}} Zeilen mit Problemen',
    importApplied: 'Versandkosten für {{count}} Sendungen gespeichert.',
    rowStatus: { ready: 'Bereit', exists: 'Bereits erfasst', error: 'Problem' },
    row: 'Zeile',
    status: 'Status',
    problem: 'Details',
    addRule: 'Schätzregel hinzufügen',
    editRule: 'Schätzregel bearbeiten',
    saveRule: 'Regel speichern',
    ruleSaved: 'Schätzregel gespeichert.',
    ruleDeleted: 'Schätzregel gelöscht.',
    confirmDeleteRule: 'Diese Schätzregel löschen?',
    maxWeight: 'Höchstgewicht pro Paket (kg)',
    noLimit: 'Ohne Grenze',
    cost: 'Kosten pro Sendung (ohne MwSt.)',
    emptyRules: 'Keine Schätzregeln',
    emptyRulesLead:
      'Geben Sie die Preisliste Ihres Versanddienstleisters ein; Sendungen ohne erfasste Kosten werden dann geschätzt.',
    kg: '{{kg}} kg',
    category: 'Kategorie',
    allCategories: 'Alle Kategorien',
    categories: {
      rent: 'Miete',
      salary: 'Gehälter und Personal',
      marketing: 'Marketing (ohne Werbeanzeigen)',
      software: 'Software und Abonnements',
      packaging: 'Verpackung',
      logistics: 'Lager und Logistik',
      utilities: 'Nebenkosten',
      professional: 'Buchhaltung, Recht, Beratung',
      tax_fees: 'Steuern und Gebühren',
      other: 'Sonstiges',
    },
    expenseDate: 'Datum',
    description: 'Beschreibung',
    store: 'Shop',
    noStore: 'Gesamtes Unternehmen',
    addExpense: 'Ausgabe hinzufügen',
    editExpense: 'Ausgabe bearbeiten',
    saveExpense: 'Ausgabe speichern',
    expenseSaved: 'Ausgabe gespeichert.',
    expenseDeleted: 'Ausgabe gelöscht.',
    confirmDeleteExpense: 'Diese Ausgabe löschen?',
    emptyExpenses: 'Keine Ausgaben in diesem Zeitraum',
    emptyExpensesLead:
      'Erfassen Sie Miete, Gehälter, Software und ähnliche Kosten; sie fließen in den Nettogewinn und den Cashflow ein. Werbeausgaben kommen aus dem Werbezentrum.',
    expensesTotal: 'Summe: {{amount}} (MwSt. {{vat}})',
  },
  financeReport: {
    navLabel: 'Finanzbericht',
    tiles: {
      revenue: 'Erlöse (ohne MwSt.)',
      grossProfit: 'Rohertrag',
      contribution: 'Deckungsbeitrag',
      operatingProfit: 'Betriebsergebnis',
      netCash: 'Netto-Cashflow',
    },
    marginOf: 'Vom Erlös: {{pct}}',
    grossUnknown:
      'Für einen Teil der Umsätze fehlen Kosten; der Rohertrag kann höher erscheinen, als er ist.',
    pnlTitle: 'Rentabilität (Bestellbasis, ohne MwSt.)',
    rows: {
      netSales: 'Nettoumsatz (inkl. MwSt.)',
      revenue: 'Erlöse (Nettoumsatz ohne MwSt.)',
      cogs: 'Wareneinsatz',
      grossProfit: 'Rohertrag',
      shipping: 'Versandkosten',
      fees: 'Zahlungsgebühren',
      ads: 'Werbeausgaben',
      disputes: 'Verluste und Gebühren aus Rückbuchungen',
      contribution: 'Deckungsbeitrag',
      expenses: 'Betriebsausgaben',
      operatingProfit: 'Betriebsergebnis',
    },
    statuses: { complete: 'Vollständig', partial: 'Teilweise', missing: 'Keine Daten' },
    notes: {
      cogsUnknown:
        'Für {{amount}} Umsatz fehlen die Kosten; der Rohertrag erscheint höher, als er ist. Rohertragsmarge der Positionen mit bekannten Kosten: {{pct}}.',
      cogsUnknownAll:
        'Die Kosten von {{amount}} Umsatz sind unbekannt; der Rohertrag erscheint höher, als er ist.',
      cogsLate: '{{amount}} der Kosten wurden später erfasst (geschätzt).',
      shippingEstimated: '{{amount}} aus Schätzregeln berechnet.',
      shippingUnknown: 'Kosten für {{count}} Sendungen unbekannt (nicht erfasst, keine Schätzregel).',
      feesUnknown: 'Keine Gebührenregel für {{count}} Kartenzahlungen.',
      adsMissing: 'Kein Werbekonto verbunden; Werbeausgaben werden mit null angesetzt.',
      adsFx: 'Für einige Tage mit Werbeausgaben in Fremdwährung fehlt ein Wechselkurs.',
      disputes:
        '{{count}} verlorene oder akzeptierte Rückbuchungen: {{lost}} (inkl. MwSt.; Ware gilt als nicht zurückgegeben) und Rückbuchungsgebühren {{fees}}.',
    },
    goInputs: 'Zu den Finanzeingaben',
    pnlCols: { item: 'Posten', amount: 'Betrag', share: 'Vom Erlös', status: 'Datenstand' },
    expenseOf: 'Ausgabe: {{name}}',
    cashFx: '{{count}} Zahlungen in Fremdwährung ohne Wechselkurs wurden im Cashflow nicht berücksichtigt.',
    dealerCollectionsHidden:
      'Händlerzahlungseingänge gelten unternehmensweit; bei Shop-, Kanal- oder Endkundenfilter und für Benutzer mit Shop-Beschränkung ausgeblendet.',
    inByMethod: 'Erhaltene Zahlungen: {{name}}',
    noData: 'Für diesen Zeitraum gibt es keine Daten.',
    noProducts: 'In diesem Zeitraum wurden keine Produkte verkauft.',
    showingProducts: 'Die {{count}} umsatzstärksten Produkte werden angezeigt.',
    cashTitle: 'Cashflow (nach Buchungsdatum)',
    cashRows: {
      in: 'Einzahlungen',
      dealerCollections: 'Händlerzahlungseingänge (Kundenkonto)',
      out: 'Auszahlungen',
      refunds: 'Erstattungen',
      fees: 'Zahlungsgebühren',
      shipping: 'Zahlungen an Versanddienstleister (inkl. MwSt.)',
      expenses: 'Betriebsausgaben (inkl. MwSt.)',
      ads: 'Werbeausgaben',
      suppliers: 'Zahlungen an Lieferanten',
      disputes: 'Rückbuchungen (verlorener Betrag und Gebühren)',
      net: 'Netto-Cashflow',
    },
    cashNote:
      'Ungefähre Managementsicht, keine Bankabstimmung. Gebühren werden aus Ihren Gebührenregeln berechnet.',
    vatTitle: 'MwSt.-Übersicht',
    vatRows: {
      output: 'MwSt. auf Umsätze',
      inputExpenses: 'Gezahlte MwSt. auf Ausgaben',
      inputShipping: 'Gezahlte MwSt. auf Versand',
      inputPurchases: 'MwSt. auf Lieferantenrechnungen (Einkauf)',
      difference: 'Differenz',
    },
    vatNote:
      'Die MwSt. auf Einkäufe stammt aus den beim Wareneingang gebuchten Lieferantenrechnungen. Keine Steuererklärung — bitte mit Ihrem Steuerberater abstimmen.',
    balancesTitle: 'Forderungen und Verbindlichkeiten (heute)',
    balanceRows: {
      dealerReceivables: 'Forderungen an Händler ({{count}} Händler im Soll)',
      openDisputes: 'Offene Rückbuchungen — gefährdeter Betrag ({{count}} Fälle)',
      codInTransit: 'Nachnahme unterwegs ({{count}} Bestellungen)',
      supplierPayables:
        'Verbindlichkeiten gegenüber Lieferanten ({{count}} Lieferanten · überfällig {{overdue}})',
    },
    dealerScopeHidden: 'Nicht angezeigt: Ihr Zugriff ist auf einige Shops beschränkt',
    openDisputesLink: 'Offene Rückbuchungen',
    feesTitle: 'Zahlungsgebühren nach Zahlungsart',
    feeCols: {
      provider: 'Zahlungsart',
      processed: 'Abgewickelt',
      fee: 'Gebühr',
      noRule: 'Zahlungen ohne Regel',
    },
    productsTitle: 'Produktrentabilität',
    productCols: {
      product: 'Produkt',
      revenue: 'Erlöse (ohne MwSt.)',
      cogs: 'Wareneinsatz',
      grossProfit: 'Rohertrag',
      margin: 'Marge',
    },
    unknownCost: 'Kosten unbekannt',
    estimatedCost: 'geschätzte Kosten',
    channelsTitle: 'Kanalrentabilität',
    channelCols: {
      channel: 'Kanal',
      revenue: 'Erlöse',
      cogs: 'Wareneinsatz',
      shipping: 'Versand',
      fees: 'Gebühren',
      contribution: 'Deckungsbeitrag (ohne Werbung)',
    },
    reconTitle: 'Zahlungsabgleich',
    reconCols: {
      provider: 'Anbieter',
      status: 'Letzter Lauf',
      finished: 'Datum',
      open: 'Offene Differenzen',
    },
    reconStatus: { running: 'Läuft', ok: 'Abgeglichen', mismatch: 'Differenzen', error: 'Fehler' },
    reconEmpty: 'Noch kein Abgleich durchgeführt.',
    openPayments: 'Zu den Zahlungen',
    missingTitle: 'Ohne Kosten verkaufte Produkte',
    missingLead:
      'In diesem Zeitraum ohne Kosten verkaufte Produkte (meistverkaufte zuerst). Erfassen Sie die Kosten am Produkt; spätere Bestellungen verwenden sie, frühere werden als „geschätzt“ erfasst.',
    missingCols: { product: 'Produkt', sku: 'SKU', quantity: 'Verkaufte Einheiten' },
    missingNone: 'Alle in diesem Zeitraum verkauften Produkte haben Kosten.',
    coverage:
      'Kosten zum Verkaufszeitpunkt: {{snapshot}} Positionen · später erfasst: {{late}} · unbekannt: {{missing}}',
  },
  stockReport: {
    navLabel: 'Bestandsbericht',
    warehouse: 'Lager',
    allWarehouses: 'Alle Lager',
    slowDays: 'Schwelle für Ladenhüter',
    slowDaysOption: 'Kein Verkauf seit {{days}} Tagen',
    tilesTitle: 'Bestandsübersicht',
    tiles: {
      value: 'Bestandswert',
      units: 'Einheiten am Lager',
      turnover: 'Umschlag (Zeitraum)',
      daysOfInventory: 'Lagerreichweite in Tagen',
      slow: 'Ladenhüter',
    },
    unitsSub: '{{count}} Varianten auf Lager',
    valueSub: 'Zu aktuellen Kosten, ohne MwSt.',
    unknownCostSub: '{{count}} Einheiten ohne Kosten',
    turnoverValue: '{{x}}-mal',
    turnoverSub: '{{sold}} Einheiten verkauft · durchschnittlicher Bestand {{avg}} Einheiten',
    daysValue: '{{days}} Tage',
    noSales: 'Keine Verkäufe im Zeitraum',
    slowSub: '{{count}} Varianten · {{units}} Einheiten',
    costHidden:
      'Sie dürfen keine Kosten sehen; Bestandswert und Kostenspalten sind ausgeblendet, Einheiten und Umschlag sind vollständig.',
    method:
      'Bestandswert = Einheiten am Lager × aktuelle Produktkosten (ohne MwSt.; Kosten in Fremdwährung zum letzten TCMB-Kurs). Die Kosten werden beim Wareneingang als gleitender Durchschnitt aktualisiert.',
    negative: '{{count}} Einheiten sind negativ (vor dem Eingang verkauft); nicht bewertet.',
    fxMissing: 'Für die Kostenwährung von {{count}} Varianten fehlt ein Wechselkurs; nicht bewertet.',
    alertsTitle: 'Bestand mit Handlungsbedarf',
    alerts: {
      expired: 'Abgelaufen',
      expiring: 'Läuft innerhalb von {{days}} Tagen ab',
      critical: 'Auf oder unter dem kritischen Bestand',
    },
    alertUnits: '{{units}} Einheiten',
    alertVariants: '{{count}} Varianten',
    goStock: 'Im Bestand öffnen',
    warehousesTitle: 'Bestand nach Lager',
    warehouseCols: {
      warehouse: 'Lager',
      variants: 'Varianten',
      units: 'Einheiten am Lager',
      value: 'Bestandswert',
      unknown: 'Einheiten ohne Kosten',
    },
    inactive: 'inaktiv',
    categoriesTitle: 'Bestand nach Kategorie',
    categoryNote:
      'Produkte in mehreren Kategorien zählen in jeder; die Zeilen können zusammen mehr als die Gesamtsumme ergeben.',
    categoryCols: {
      category: 'Kategorie',
      units: 'Einheiten am Lager',
      value: 'Bestandswert',
      sold: 'Im Zeitraum verkauft',
    },
    variantsTitle: 'Bestand und Umschlag nach Variante',
    slowTitle: 'Ladenhüter',
    slowLead: 'Varianten mit Bestand und ohne Verkauf in den letzten {{days}} Tagen (nach Bestandswert).',
    slowNone: 'Keine Ladenhüter.',
    variantCols: {
      product: 'Produkt',
      onHand: 'Am Lager',
      available: 'Verfügbar',
      unitCost: 'Stückkosten',
      value: 'Bestandswert',
      sold: 'Im Zeitraum verkauft',
      turnover: 'Umschlag',
      cover: 'Reichweite',
      lastSale: 'Letzter Verkauf',
    },
    noCost: 'keine Kosten',
    uncategorized: 'Ohne Kategorie',
    never: 'Nie verkauft',
    showing:
      'Die {{shown}} wertvollsten von {{total}} Varianten werden angezeigt; der Download enthält alle.',
    empty: 'Keine Produkte auf Lager.',
  },
  purchasing: {
    navSuppliers: 'Lieferanten',
    navOrders: 'Einkauf',
    navReceive: 'Wareneingang',
    statuses: {
      requested: 'Anforderung',
      ordered: 'Bestellt',
      partially_received: 'Teilweise eingegangen',
      received: 'Vollständig eingegangen',
      closed: 'Abgeschlossen',
      cancelled: 'Storniert',
    },
    filters: { all: 'Alle Bestellungen', open: 'Offene Bestellungen' },
    supplier: 'Lieferant',
    supplierStatus: { active: 'Aktiv', inactive: 'Inaktiv' },
    addSupplier: 'Lieferant hinzufügen',
    editSupplier: 'Lieferant bearbeiten',
    saveSupplier: 'Lieferant speichern',
    supplierSaved: 'Lieferant gespeichert.',
    fields: {
      name: 'Firmenname',
      code: 'Code',
      taxOffice: 'Finanzamt',
      taxNumber: 'Steuer-/Identifikationsnummer',
      contactName: 'Ansprechpartner',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      currency: 'Währung',
      paymentTermDays: 'Zahlungsziel (Tage)',
      leadTimeDays: 'Lieferzeit (Tage)',
      note: 'Notiz',
      status: 'Status',
    },
    supplierCols: {
      supplier: 'Lieferant',
      contact: 'Kontakt',
      terms: 'Zahlungsziel',
      balance: 'Saldo',
      overdue: 'Überfällig',
      status: 'Status',
    },
    noSuppliers: 'Noch keine Lieferanten',
    noSuppliersLead:
      'Legen Sie die Firmen an, bei denen Sie einkaufen; Bestellscheine und das Lieferantenkonto gehören zu einem Lieferanten.',
    termsDays: '{{days}} Tage',
    cash: 'Bar',
    performanceTitle: 'Lieferantenleistung',
    performanceLead:
      'Basierend auf den im Zeitraum aufgegebenen Bestellungen; Einkaufsvolumen aus den im Zeitraum eingegangenen Waren (ohne MwSt.).',
    perfCols: {
      supplier: 'Lieferant',
      orders: 'Bestellungen',
      onTime: 'Pünktlich',
      fill: 'Lieferquote',
      short: 'Unterlieferungen',
      over: 'Überlieferungen',
      lead: 'Ø Lieferzeit',
      spend: 'Einkaufsvolumen',
    },
    late: '{{count}} verspätet',
    ledgerTitle: 'Kontoauszug',
    ledgerLead:
      'Positive Beträge schulden Sie dem Lieferanten; negative sind Zahlungen oder Gutschriften. Rechnungen aus dem Wareneingang werden automatisch gebucht.',
    addEntry: 'Buchung hinzufügen',
    saveEntry: 'Buchung speichern',
    entrySaved: 'Buchung hinzugefügt.',
    reverse: 'Stornieren',
    reverseTitle: 'Mit Gegenbuchung korrigieren',
    reverseReason: 'Grund',
    reverseSave: 'Gegenbuchung erstellen',
    reversed: 'Gegenbuchung erstellt.',
    kinds: {
      opening: 'Eröffnungssaldo',
      invoice: 'Rechnung (Wareneingang)',
      payment: 'Zahlung',
      return: 'Rücksendung / Gutschrift',
      adjustment: 'Korrektur',
      reversal: 'Gegenbuchung',
    },
    directions: { debit: 'Verbindlichkeit erhöhen', credit: 'Verbindlichkeit verringern' },
    methods: {
      bank_transfer: 'Banküberweisung',
      cash: 'Bar',
      cheque: 'Scheck',
      note: 'Wechsel',
      card: 'Karte',
      other: 'Sonstiges',
    },
    entryFields: {
      kind: 'Buchungsart',
      amount: 'Betrag',
      direction: 'Richtung',
      date: 'Datum',
      dueDate: 'Fälligkeitsdatum',
      method: 'Zahlungsart',
      reference: 'Beleg- / Dokumentnummer',
      description: 'Beschreibung',
    },
    ledgerCols: {
      date: 'Datum',
      kind: 'Buchung',
      description: 'Beschreibung',
      due: 'Fällig',
      amount: 'Betrag',
      balance: 'Saldo',
    },
    noEntries: 'Keine Buchungen.',
    balanceLine: 'Saldo: {{amount}} · überfällig: {{overdue}}',
    reversedMark: 'storniert',
    ordersOfSupplier: 'Bestellungen bei diesem Lieferanten',
    newOrder: 'Neue Einkaufsanforderung',
    noOrders: 'Keine Bestellscheine',
    noOrdersLead:
      'Erstellen Sie eine Anforderung; „Bestellen“ markiert sie als an den Lieferanten gesendet, die Ware wird bei Ankunft im Wareneingang erfasst.',
    orderCols: {
      number: 'Nr.',
      supplier: 'Lieferant',
      warehouse: 'Lager',
      expected: 'Erwartet',
      status: 'Status',
      progress: 'Eingegangen',
      total: 'Summe (inkl. MwSt.)',
    },
    progress: '{{received}} / {{ordered}}',
    warehouse: 'Empfangslager',
    expectedDate: 'Erwartetes Lieferdatum',
    note: 'Notiz',
    linesTitle: 'Produkte',
    addProduct: 'Produkt hinzufügen',
    lineCols: {
      product: 'Produkt',
      quantity: 'Menge',
      received: 'Eingegangen',
      remaining: 'Offen',
      unitCost: 'Stückkosten (ohne MwSt.)',
      tax: 'MwSt. %',
      total: 'Betrag (ohne MwSt.)',
    },
    taxDefault: 'MwSt.-Satz des Produkts',
    removeLine: 'Position entfernen',
    totals: { subtotal: 'Zwischensumme (ohne MwSt.)', tax: 'MwSt.', total: 'Summe (inkl. MwSt.)' },
    createOrder: 'Anforderung erstellen',
    saveOrder: 'Anforderung speichern',
    orderCreated: 'Einkaufsanforderung erstellt.',
    orderSaved: 'Gespeichert.',
    editLines: 'Anforderung bearbeiten',
    placeOrder: 'Bestellen',
    placeConfirm:
      'Die Anforderung wird als beim Lieferanten bestellt markiert; die Positionen können danach nicht mehr geändert werden. Fortfahren?',
    placed: 'Als bestellt markiert.',
    cancelOrder: 'Bestellung stornieren',
    cancelConfirm:
      'Die Bestellung wird storniert. Nur Bestellungen ohne Wareneingang können storniert werden.',
    cancelled: 'Bestellung storniert.',
    closeOrder: 'Bestellung abschließen',
    closeConfirm: 'Offene Mengen werden nicht mehr erwartet; die Bestellung wird abgeschlossen.',
    closed: 'Bestellung abgeschlossen.',
    print: 'Drucken',
    orderInfo: 'Bestelldetails',
    requestedOn: 'Angefordert am',
    orderedOn: 'Bestellt am',
    noExpected: 'Nicht festgelegt',
    changeDate: 'Datum ändern',
    saveDate: 'Datum speichern',
    receiptsTitle: 'Wareneingänge',
    noReceipts: 'Noch keine Ware eingegangen.',
    receiptLine: '{{number}} · {{date}} · {{count}} Positionen',
    invoiceNo: 'Rechnungs- / Lieferscheinnummer',
    lot: 'Charge {{lot}}',
    expiry: 'MHD {{date}}',
    pickSupplier: 'Lieferant wählen',
    pickWarehouse: 'Lager wählen',
    quantityInvalid: 'Die Menge muss eine ganze Zahl ab 1 sein.',
    costInvalid: 'Betrag konnte nicht gelesen werden (z. B. 120,50).',
    receiveTitle: 'Wareneingang: {{number}}',
    receive: 'Ware annehmen',
    receiveSave: 'Wareneingang speichern',
    received: 'Wareneingang gespeichert; Bestand aktualisiert.',
    receiveLead:
      'Erfassen Sie die eingegangenen Mengen; fehlende Positionen bleiben bei 0. Bei chargengeführten Produkten Chargennummer und Mindesthaltbarkeitsdatum eingeben.',
    receivedOn: 'Eingegangen am',
    receiveCols: {
      product: 'Produkt',
      remaining: 'Offen',
      quantity: 'Eingangsmenge',
      lot: 'Chargen-Nr.',
      expiry: 'MHD',
      cost: 'Stückkosten laut Rechnung',
    },
    acceptOver: 'Mehr als die offene Menge annehmen (Überlieferung)',
    postInvoice: 'Rechnung auf das Lieferantenkonto buchen (inkl. MwSt., mit Zahlungsziel)',
    updateCost: 'Produktkosten aktualisieren (gleitender gewichteter Durchschnitt)',
    nothingToReceive: 'Geben Sie in mindestens einer Position eine Menge ein.',
    receivableEmpty: 'Keine Bestellungen, die auf Wareneingang warten',
    receivableLead:
      'Bei Lieferanten bestellte und noch nicht vollständig eingegangene Bestellungen. Kosten werden hier nicht angezeigt.',
    receivableCols: {
      number: 'Bestellung',
      supplier: 'Lieferant',
      warehouse: 'Lager',
      expected: 'Erwartet',
      lines: 'Offen',
    },
    remainingLines: '{{count}} Positionen · {{units}} Einheiten',
    overdueMark: 'verspätet',
    costUpdated: 'Produkte mit aktualisierten Kosten: {{count}}',
  },
  reportBuilder: {
    navLabel: 'Berichtsgenerator',
    datasets: { orders: 'Bestellungen', lines: 'Produktverkäufe', stock: 'Bestand (heute)' },
    datasetLeads: {
      orders: 'Gezählte Bestellungen wie im Umsatzbericht; Beträge in TRY, nach Bestelldatum.',
      lines:
        'Positionen gezählter Bestellungen; ohne MwSt., Erstattungen anteilig; Wareneinsatz zum Verkaufszeitpunkt.',
      stock: 'Aktueller Bestand; Wert zu aktuellen Kosten.',
    },
    metrics: {
      orders: 'Bestellungen',
      cancelledOrders: 'Stornierte Bestellungen',
      grossSales: 'Bestellsumme',
      deductions: 'Rücksendungen und Stornierungen',
      netSales: 'Nettoumsatz',
      netSalesExVat: 'Nettoumsatz (ohne MwSt.)',
      shipping: 'Versand',
      items: 'Verkaufte Einheiten',
      newCustomers: 'Neue Kunden',
      averageOrder: 'Durchschnittlicher Warenkorb',
      quantity: 'Menge',
      cogs: 'Wareneinsatz',
      grossProfit: 'Rohertrag',
      unknownCostSales: 'Umsatz mit unbekannten Kosten',
      marginBps: 'Rohertragsmarge',
      onHand: 'Am Lager',
      reserved: 'Reserviert',
      available: 'Verfügbar',
      stockValue: 'Bestandswert',
      unknownCostUnits: 'Einheiten ohne Kosten',
    },
    dims: {
      day: 'Tag',
      week: 'Woche',
      month: 'Monat',
      year: 'Jahr',
      store: 'Shop',
      channel: 'Kanal',
      segment: 'Kundentyp',
      paymentMethod: 'Zahlungsart',
      country: 'Land',
      city: 'Stadt',
      customerType: 'Neu / wiederkehrend',
      product: 'Produkt',
      variant: 'SKU',
      category: 'Kategorie',
      brand: 'Marke',
      warehouse: 'Lager',
      expiryMonth: 'MHD-Monat',
    },
    customerTypes: { new: 'Neuer Kunde', returning: 'Wiederkehrend' },
    dataset: 'Datenbestand',
    metricsLabel: 'Kennzahlen (bis zu 4)',
    row1: 'Zeilendimension',
    row2: 'Zweite Zeilendimension',
    column: 'Spaltendimension (Pivot)',
    none: 'Keine',
    filtersTitle: 'Filter',
    warehouse: 'Lager',
    category: 'Kategorie',
    brand: 'Marke',
    all: 'Alle',
    sort: 'Sortierung',
    sortAuto: 'Automatisch',
    sortDesc: '{{metric}} (absteigend)',
    sortAsc: '{{metric}} (aufsteigend)',
    limit: 'Max. Zeilen',
    run: 'Ausführen',
    resultTitle: 'Ergebnis',
    total: 'Gesamt',
    empty: 'Keine Daten für diese Auswahl.',
    hidden: 'Leer, weil Sie keine Kosten sehen dürfen: {{names}}',
    multiValued:
      'Produkte in mehreren Kategorien zählen in jeder; die Zeilen können zusammen mehr als die Gesamtsumme ergeben.',
    truncatedRows:
      'Die ersten {{shown}} von {{total}} Zeilen werden angezeigt; die Datei enthält dieselben Zeilen. Sie können das Limit erhöhen.',
    truncatedColumns: 'Die ersten 36 Spalten werden angezeigt.',
    fxMissing: '{{count}} Datensätze ohne Wechselkurs wurden nicht berücksichtigt.',
    pivotOneMetric: 'Mit einer Spaltendimension wird nur die erste Kennzahl angezeigt.',
    chartTitle: '{{metric}} — {{dim}}',
    savedTitle: 'Gespeicherte Berichte',
    savedEmpty: 'Keine gespeicherten Berichte.',
    sharedBy: 'Geteilt von {{name}}',
    mine: 'Meine',
    sharedMark: 'Geteilt',
    open: 'Öffnen',
    current: 'Geöffneter Bericht: {{name}}',
    newReport: 'Neuer Bericht',
    save: 'Bericht speichern',
    saveChanges: 'Änderungen speichern',
    saveAs: 'Als neuen Bericht speichern',
    saveTitle: 'Bericht speichern',
    name: 'Berichtsname',
    description: 'Beschreibung',
    visibility: 'Sichtbarkeit',
    visibilities: { private: 'Nur ich', shared: 'Geteilt' },
    shareRoles: 'Mit Rollen teilen',
    shareUsers: 'Mit Personen teilen',
    shareNote:
      'Personen, mit denen Sie teilen, sehen die Daten mit ihren eigenen Berechtigungen: Shop-Beschränkung und Kostenzugriff gelten.',
    saved: 'Bericht gespeichert.',
    deleteReport: 'Bericht löschen',
    deleteConfirm:
      'Der gespeicherte Bericht wird gelöscht. Personen, mit denen er geteilt wurde, sehen ihn danach nicht mehr.',
    deleted: 'Bericht gelöscht.',
    readOnly: 'Dieser Bericht wurde mit Ihnen geteilt; Änderungen können Sie als neuen Bericht speichern.',
    background: 'Im Hintergrund erstellen',
    backgroundQueued: 'Die Datei wird erstellt; laden Sie sie unter „Meine Berichtsdateien“ herunter.',
    openFiles: 'Meine Berichtsdateien',
    schedule: 'Planen',
  },
  reportWidgets: {
    title: 'Meine Berichts-Widgets',
    empty:
      'Sie haben keine Berichts-Widgets. Öffnen Sie im Berichtsgenerator einen gespeicherten oder mit Ihnen geteilten Bericht und wählen Sie „Zur Übersicht hinzufügen“.',
    goBuilder: 'Zum Berichtsgenerator',
    addToDashboard: 'Zur Übersicht hinzufügen',
    added: 'Bericht zur Übersicht hinzugefügt.',
    onDashboard: 'In der Übersicht',
    display: 'Ansicht',
    size: 'Breite',
    displays: { table: 'Tabelle', chart: 'Diagramm', number: 'Nur Summe' },
    sizes: { half: 'Halb', full: 'Voll' },
    moveUp: 'Nach oben: {{name}}',
    moveDown: 'Nach unten: {{name}}',
    remove: 'Entfernen: {{name}}',
    removed: 'Widget entfernt.',
    unavailable: 'Dieser Bericht ist nicht mehr mit Ihnen geteilt oder wurde gelöscht.',
    unavailableTitle: 'Nicht verfügbarer Bericht',
    openReport: 'Bericht öffnen',
    moreRows: '{{count}} weitere Zeilen im Bericht',
    chartUnavailable:
      'Ein Diagramm benötigt genau eine Zeilendimension und keine Spalte; die Tabelle wird angezeigt.',
    settings: 'Widget-Einstellungen: {{name}}',
  },
  reportFiles: {
    navLabel: 'Meine Berichtsdateien',
    filesTitle: 'Meine Dateien',
    filesEmpty:
      'Noch keine Dateien. Nutzen Sie im Berichtsgenerator „Im Hintergrund erstellen“ für einen großen Bericht oder richten Sie einen geplanten Bericht ein.',
    name: 'Bericht',
    format: 'Format',
    status: 'Status',
    rows: 'Zeilen',
    size: 'Größe',
    created: 'Angefordert',
    expires: 'Gelöscht am',
    source: 'Quelle',
    sources: { manual: 'Anforderung', schedule: 'Geplant', workflow: 'Automatisierungsablauf' },
    statuses: {
      queued: 'In Warteschlange',
      running: 'Wird erstellt',
      done: 'Bereit',
      failed: 'Fehlgeschlagen',
    },
    download: 'Herunterladen',
    downloadNamed: 'Herunterladen: {{name}}',
    failedGeneric: 'Die Datei konnte nicht erstellt werden; fordern Sie sie erneut an.',
    keepNote:
      'Dateien werden mit Ihren Berechtigungen erstellt, sind nur für Sie sichtbar und werden nach 30 Tagen gelöscht. Bis zu 50.000 Zeilen.',
    kb: '{{n}} KB',
    schedulesTitle: 'Geplante Berichte',
    schedulesEmpty: 'Keine geplanten Berichte.',
    newSchedule: 'Neue Planung',
    report: 'Gespeicherter Bericht',
    pickReport: 'Bericht wählen',
    noSavedReports: 'Speichern Sie zuerst einen Bericht im Berichtsgenerator.',
    frequency: 'Häufigkeit',
    frequencies: { daily: 'Täglich', weekly: 'Wöchentlich', monthly: 'Monatlich' },
    weekday: 'Tag',
    weekdays: {
      '1': 'Montag',
      '2': 'Dienstag',
      '3': 'Mittwoch',
      '4': 'Donnerstag',
      '5': 'Freitag',
      '6': 'Samstag',
      '7': 'Sonntag',
    },
    weekdaysInline: {
      '1': 'Montag',
      '2': 'Dienstag',
      '3': 'Mittwoch',
      '4': 'Donnerstag',
      '5': 'Freitag',
      '6': 'Samstag',
      '7': 'Sonntag',
    },
    monthDay: 'Tag des Monats',
    hour: 'Uhrzeit (Türkei)',
    when: {
      daily: 'Täglich {{hour}}',
      weekly: 'Jeden {{day}} {{hour}}',
      monthly: 'Am {{day}}. jedes Monats {{hour}}',
    },
    periodNote: {
      daily: 'Es wird der Bericht des Vortags gesendet.',
      weekly: 'Es wird der Bericht der Vorwoche (Montag–Sonntag) gesendet.',
      monthly: 'Es wird der Bericht des Vormonats gesendet.',
    },
    recipients: 'Empfänger',
    recipientCount: '{{count}} Empfänger',
    enabled: 'Versand aktiv',
    enabledNamed: 'Versand: {{name}}',
    on: 'An',
    off: 'Aus',
    nextRun: 'Nächster Versand',
    lastDelivery: 'Letzter Versand',
    never: 'Noch nicht',
    deliveryStatuses: {
      running: 'Wird gesendet',
      sent: 'Gesendet',
      partial: 'Teilweise',
      failed: 'Fehlgeschlagen',
    },
    deliveryCounts: '{{sent}} gesendet · {{skipped}} übersprungen',
    edit: 'Bearbeiten',
    editNamed: 'Bearbeiten: {{name}}',
    deleteNamed: 'Löschen: {{name}}',
    deleteConfirm:
      'Die Planung wird gelöscht. Bereits erstellte Dateien bleiben bis zu ihrem Ablauf erhalten.',
    deleted: 'Planung gelöscht.',
    saved: 'Planung gespeichert.',
    dialogNew: 'Bericht planen',
    dialogEdit: 'Planung bearbeiten',
    deliveryNote:
      'Die E-Mail enthält keine Berichtsdaten, nur einen Link zu dieser Seite. Die Datei jedes Empfängers wird mit dessen eigenen Berechtigungen erstellt; Empfänger, die den Bericht nicht sehen dürfen, werden übersprungen. Eine neue Planung ist aus, bis Sie den Versand aktivieren.',
    unknownReport: 'Nicht verfügbarer Bericht',
  },
  disputes: {
    navLabel: 'Rückbuchungen',
    newDispute: 'Neue Rückbuchung',
    statusFilter: 'Status',
    filters: { active: 'Offen', closed: 'Abgeschlossen', all: 'Alle' },
    empty: 'Keine Rückbuchungen erfasst.',
    emptyActive: 'Keine offenen Rückbuchungen.',
    tableTitle: 'Rückbuchungen',
    cols: {
      number: 'Fall-Nr.',
      order: 'Bestellung',
      kind: 'Art',
      status: 'Status',
      amount: 'Betrag',
      fee: 'Gebühr',
      opened: 'Eröffnet',
      due: 'Antwort bis',
      closed: 'Abgeschlossen',
    },
    kinds: { chargeback: 'Rückbuchung (Chargeback)', inquiry: 'Informationsanfrage' },
    statuses: {
      open: 'Offen',
      evidence_submitted: 'Nachweise eingereicht',
      won: 'Gewonnen',
      lost: 'Verloren',
      accepted: 'Akzeptiert',
    },
    providers: { iyzico: 'iyzico', paytr: 'PayTR', manual: 'Physisches POS / manuell' },
    overdue: 'Überfällig',
    dueSoon: 'Bald fällig',
    summary: '{{count}} offene Rückbuchungen. Der gefährdete Betrag wird im Finanzbericht angezeigt.',
    dialogTitle: 'Rückbuchung erfassen',
    orderNumber: 'Bestellnummer',
    findPayments: 'Zahlungen suchen',
    noPayments:
      'Diese Bestellung hat keine Zahlung, für die eine Rückbuchung erfasst werden kann. Rückbuchungen gelten nur für Karten- oder physische POS-Zahlungen.',
    payment: 'Zahlung',
    paymentOption: '{{provider}} · {{amount}} · {{date}}',
    alreadyDisputed: 'Bereits strittiger Betrag: {{amount}}',
    kind: 'Art',
    caseNumber: 'Fallnummer der Bank / des Anbieters',
    reasonCode: 'Grundcode',
    reason: 'Grund',
    amount: 'Strittiger Betrag',
    fee: 'Rückbuchungsgebühr',
    openedOn: 'Datum der Benachrichtigung',
    responseDueOn: 'Antwort bis',
    note: 'Notiz',
    amountInvalid: 'Der Betrag konnte nicht gelesen werden.',
    created: 'Rückbuchung erfasst.',
    saved: 'Rückbuchung aktualisiert.',
    providerNote:
      'Der Datensatz wird in der Verwaltung geführt; an die Bank oder den Zahlungsanbieter wird nichts gesendet. Reichen Sie Ihre Antwort und Unterlagen im Portal des Anbieters ein.',
    detailTitle: 'Rückbuchung {{number}}',
    back: 'Rückbuchungen',
    infoTitle: 'Details',
    order: 'Bestellung',
    paymentInfo: 'Zahlung',
    paymentLine: '{{provider}} · {{amount}}',
    refunded: 'Erstattet: {{amount}}',
    actionsTitle: 'Status',
    moveTo: {
      evidence_submitted: 'Als „Nachweise eingereicht“ markieren',
      won: 'Gewonnen',
      lost: 'Verloren',
      accepted: 'Akzeptieren (nicht anfechten)',
      open: 'Wieder öffnen',
    },
    statusDialog: 'Status ändern: {{status}}',
    closedOn: 'Abschlussdatum',
    statusNote: 'Kommentar',
    reopenNote: 'Zum Wiedereröffnen ist ein Grund (z. B. Schiedsverfahren) erforderlich.',
    lossNote:
      'Ein verlorener oder akzeptierter Betrag wird im Finanzbericht vom Gewinn (Zeitraum der Bestellung) und vom Cashflow (Abschlussdatum) abgezogen.',
    statusChanged: 'Status geändert.',
    edit: 'Korrigieren',
    editTitle: 'Rückbuchung korrigieren',
    documentsTitle: 'Dokumente',
    noDocuments: 'Keine Dokumente hinzugefügt.',
    upload: 'Dokument hinzufügen',
    uploadHint: 'PDF, JPEG oder PNG; bis 10 MB. Dokumente sind nur in der Verwaltung sichtbar.',
    uploaded: 'Dokument hinzugefügt.',
    downloadNamed: 'Herunterladen: {{name}}',
    notesTitle: 'Notiz hinzufügen',
    addNote: 'Notiz hinzufügen',
    noteAdded: 'Notiz hinzugefügt.',
    historyTitle: 'Verlauf',
    events: {
      created: 'Erfasst',
      status: 'Status: {{from}} → {{to}}',
      updated: 'Angaben korrigiert',
      note: 'Notiz',
      document: 'Dokument hinzugefügt: {{name}}',
    },
    by: '{{name}}',
    system: 'System',
  },
  priceSimulation: {
    navLabel: 'Preissimulation',
    priceList: 'Preisliste (TRY)',
    category: 'Kategorie',
    brand: 'Marke',
    days: 'Zeitraum für die Absatzmenge',
    lastDays: 'Letzte {{count}} Tage',
    priceChange: 'Preisänderung (%)',
    costChange: 'Kostenänderung (%)',
    feeRate: 'Gebührensatz (%)',
    feeDefault: 'leer: effektiver Satz des Zeitraums',
    minMargin: 'Mindestmarge (%)',
    percentInvalid: 'Der Prozentsatz konnte nicht gelesen werden (z. B. 10, -5, 2,5).',
    run: 'Berechnen',
    noWrite: 'Preise werden nicht geändert; es wird nur berechnet.',
    noLists: 'Keine Preislisten in TRY.',
    summary: 'Simulationsübersicht',
    currentContribution: 'Deckungsbeitrag des Zeitraums (aktuell)',
    scenarioContribution: 'Deckungsbeitrag des Zeitraums (Szenario)',
    periodOf: 'Mit der Absatzmenge von {{from}} – {{to}}',
    changeOf: 'Differenz: {{amount}}',
    feeUsed: 'Gebühr im Szenario',
    feeCurrent: 'Effektiver Satz des Zeitraums {{pct}} ({{count}} Zahlungen)',
    feeNone: 'Keine Zahlungen im Zeitraum; effektiver Satz mit 0 % angesetzt.',
    warnings: 'Markierte Produkte',
    warningsOf: '{{negative}} mit Verlust · {{low}} unter der Mindestmarge',
    assumption:
      'Deckungsbeitrag = Preis ohne MwSt. − Kosten − Gebühr. Es wird angenommen, dass sich die Absatzmenge mit dem Preis nicht ändert; Versand und Werbung werden nicht pro Einheit verteilt.',
    noCost: '{{count}} Produkte ohne Kosten wurden nicht berücksichtigt.',
    feeUnknown: 'Keine Gebührenregel für {{count}} Kartenzahlungen; der effektive Satz kann zu niedrig sein.',
    unitsHidden:
      'Für die Absatzmenge ist die Berechtigung „Umsatzberichte“ erforderlich; die Auswirkung auf den Zeitraum wurde nicht berechnet.',
    truncated: 'Die ersten {{count}} Produkte werden angezeigt (markierte zuerst).',
    tableTitle: 'Stückwirtschaftlichkeit nach Produkt (aktuell → Szenario)',
    empty: 'Keine Produkte mit Preis und Kosten entsprechen der Auswahl.',
    cols: {
      product: 'Produkt',
      units: 'Verkaufte Einheiten',
      price: 'Preis',
      net: 'Ohne MwSt.',
      cost: 'Kosten',
      fee: 'Gebühr',
      contribution: 'Stückdeckungsbeitrag',
      margin: 'Marge',
    },
    loss: 'Verlust',
    low: 'Niedrige Marge',
    goBulk: 'Zur Massenpreisbearbeitung, um Preise anzuwenden',
  },
  marketingSummary: {
    navLabel: 'Marketing- und SEO-Übersicht',
    funnelTitle: 'Storefront-Trichter (Serverdaten)',
    funnel: {
      carts: 'In den Warenkorb gelegt',
      checkouts: 'Bestellschritt',
      orders: 'Bestätigte Bestellungen',
    },
    stepRate: 'Vom vorherigen Schritt: {{pct}}',
    funnelOverall: 'Vom Warenkorb zur bestätigten Bestellung: {{pct}}.',
    funnelNote:
      'Produktaufrufe werden nicht auf dem Server gespeichert (sie liegen in GA4, mit Einwilligung). Der Bestellschritt umfasst ausstehende und fehlgeschlagene Zahlungen. Ein Besucher kann mehrere Warenkörbe öffnen.',
    customersTitle: 'Kundengewinnung und Kundenwert',
    newCustomers: 'Neue Kunden',
    returning: 'Wiederkehrend: {{count}}',
    cac: 'Werbekosten pro Neukunde (CAC)',
    cacOf: 'Werbeausgaben: {{spend}}',
    cacHidden:
      'Werbedaten gelten unternehmensweit; mit Shop-Filter oder ohne Werbe-Berechtigung nicht angezeigt.',
    noAds: 'Kein Werbekonto verbunden.',
    value12m: 'Kundenwert (12 Monate)',
    value12mOf: '{{customers}} Kunden in den letzten 12 Monaten · {{orders}} Bestellungen pro Kunde',
    valueToCac: 'Kundenwert ÷ CAC',
    valueToCacNote: 'Historischer 12-Monats-Wert; keine Prognose.',
    adsTitle: 'Werbung',
    adSpend: 'Ausgaben',
    clicks: 'Klicks',
    ctr: 'Klickrate',
    cpc: 'Kosten pro Klick',
    openAds: 'Werbezentrum öffnen',
    seoTitle: 'Organische Suche (Search Console)',
    seoNotLinked: 'Search Console ist nicht verbunden.',
    organicClicks: 'Organische Klicks',
    impressions: 'Impressionen',
    position: 'Durchschnittliche Position',
    seoLast: 'Neueste Daten: {{date}} (Search-Console-Daten sind 2–3 Tage verzögert).',
    seoNoData: 'Keine synchronisierten Daten für diesen Zeitraum.',
    messagingTitle: 'E-Mail- und Nachrichtenkampagnen',
    channel: 'Kanal',
    sent: 'Gesendet',
    delivered: 'Zugestellt',
    clicked: 'Geklickt',
    email: 'E-Mail',
    channels: { sms: 'SMS', whatsapp: 'WhatsApp' },
    sourcesTitle: 'Last-Touch-Quelle der Bestellungen (Storefront)',
    sourcesEmpty: 'Keine Storefront-Bestellungen in diesem Zeitraum.',
    source: 'Quelle / Medium',
    orders: 'Bestellungen',
    share: 'Anteil',
    sourceKinds: { direct: 'Direkt / unbekannt', no_consent: 'Keine Cookie-Einwilligung (Quelle unbekannt)' },
    openAttribution: 'Quellenbericht öffnen',
    fxMissing:
      '{{count}} Bestellungen in Fremdwährung ohne Wechselkurs wurden bei den Umsatzzahlen nicht berücksichtigt.',
  },
  multiTouch: {
    navLabel: 'Multi-Touch-Attribution',
    dimension: 'Aufschlüsselung',
    dimensions: { source_medium: 'Quelle / Medium', campaign: 'Kampagne' },
    summary: 'Attributionsübersicht',
    orders: 'Bestätigte Storefront-Bestellungen',
    attributed: 'Bestellungen mit bekannter Quelle',
    attributedOf: 'Mit Cookie-Einwilligung und mindestens einem Kontaktpunkt',
    withPath: 'Bestellungen mit mittleren Kontaktpunkten',
    withPathOf: 'Mittlere Kontaktpunkte werden seit Einführung dieser Funktion erfasst',
    avgTouches: 'Durchschnittliche Kontaktpunkte pro Bestellung',
    tableTitle: 'Bestellanteil und Nettoumsatz nach Modell',
    models: {
      first: 'Erster Kontakt',
      last: 'Letzter Kontakt',
      linear: 'Linear',
      position: 'Positionsbasiert (U)',
    },
    orderShare: 'Bestellungen',
    revenue: 'Nettoumsatz',
    kinds: {
      direct: 'Direkt / kein Kontaktpunkt',
      no_consent: 'Keine Cookie-Einwilligung (Quelle unbekannt)',
    },
    noCampaign: 'Keine Kampagne',
    empty: 'Keine bestätigten Storefront-Bestellungen in diesem Zeitraum.',
    note: 'Linear: gleicher Anteil pro Kontaktpunkt. Positionsbasiert (U): je 40 % für ersten und letzten Kontakt, zusammen 20 % für die mittleren Kontaktpunkte (bei zwei Kontakten 50/50). Bestellanteile und Nettoumsatz (inkl. MwSt., nach Erstattungen und Stornierungen) werden ohne Rest verteilt.',
    pathNote:
      'Aufeinanderfolgende Besuche aus derselben Quelle zählen als ein Kontaktpunkt; bis zu 5 mittlere Kontaktpunkte werden gespeichert. Mittlere Kontaktpunkte gibt es für Bestellungen nach Einführung dieser Funktion; bei früheren Bestellungen verwenden Linear und U nur den ersten und letzten Kontakt.',
    fxMissing: '{{count}} Bestellungen in Fremdwährung ohne Wechselkurs wurden nicht berücksichtigt.',
  },
  workflows: {
    navLabel: 'Automatisierungsabläufe',
    lead: 'Abläufe, die von selbst handeln, wenn etwas geschieht (neues Produkt, bezahlte Bestellung, kritischer Bestand, Periodenende…): Sie prüfen die Bedingungen und führen die Aktionen aus. Ein Ablauf verarbeitet Ereignisse ab dem Einschalten; Aktionen laufen mit den aktuellen Berechtigungen der Person, die ihn eingeschaltet hat, und jeder Schritt wird protokolliert. Nachrichten an Kunden (Warenkorb-Erinnerungen, Wieder-verfügbar-Hinweise) bleiben in ihren eigenen Bereichen mit Einwilligungs- und İYS-Prüfung.',
    newFlow: 'Neuer Ablauf',
    newFlowName: 'Neuer Ablauf',
    pauseAll: 'Alle anhalten',
    pauseAllConfirm:
      'Alle aktiven Abläufe werden angehalten und ausstehende Läufe abgebrochen. Sind Sie sicher?',
    pausedAll: '{{count}} Abläufe angehalten.',
    autoPausedAlert:
      '{{count}} Abläufe haben sich selbst angehalten; beheben Sie die Ursache und schalten Sie sie wieder ein:',
    flowsTitle: 'Abläufe',
    summaryLine:
      '{{active}} von {{total}} Abläufen sind eingeschaltet · {{failed}} fehlgeschlagene Läufe in den letzten 7 Tagen',
    flowsEmpty: 'Noch keine Abläufe. Beginnen Sie mit einem der fertigen Beispiele unten.',
    columns: {
      name: 'Ablauf',
      chain: 'Auslöser → Aktionen',
      status: 'Status',
      runs: 'Letzte 7 Tage',
      last: 'Letzter Lauf',
    },
    runAsShort: 'Eingeschaltet von: {{name}}',
    runsCounts: '{{succeeded}} erfolgreich · {{failed}} fehlgeschlagen · {{pending}} ausstehend',
    never: 'Noch nicht gelaufen',
    next: 'Nächster Lauf: {{date}}',
    statuses: { draft: 'Entwurf', active: 'Eingeschaltet', paused: 'Angehalten', archived: 'Archiviert' },
    pausedReasons: {
      manual: 'Manuell angehalten.',
      rate_limited: 'Hat sich selbst angehalten, weil das stündliche Laufzeitlimit überschritten wurde.',
      owner_inactive:
        'Hat sich selbst angehalten, weil die Mitgliedschaft der einschaltenden Person beendet wurde.',
      owner_permission:
        'Hat sich selbst angehalten, weil der einschaltenden Person eine benötigte Berechtigung fehlt.',
    },
    templatesTitle: 'Fertige Beispiele',
    useTemplate: 'Mit diesem Beispiel beginnen',
    useTemplateNamed: 'Mit dem Beispiel „{{name}}“ beginnen',
    linked: 'Kundennachricht — im eigenen Bereich',
    linkedOn: 'An',
    linkedOff: 'Aus',
    openLinked: 'Zu den Einstellungen',
    templates: {
      new_product_seo_merchant: {
        name: 'Neues Produkt → SEO-Prüfung → Merchant Center',
        text: 'Prüft beim Anlegen eines Produkts die SEO-Regeln (Titel, Beschreibung, Bild, Barcode); ohne Probleme werden die Produkte des Shops mit dem Merchant Center synchronisiert, sonst stoppt der Ablauf und protokolliert die Probleme.',
      },
      price_change_feed_log: {
        name: 'Preis geändert → Feed aktualisieren → Änderungsprotokoll',
        text: 'Synchronisiert bei einer Preisänderung die Produkte des Shops mit dem Merchant Center und schreibt das Ereignis ins Prüfprotokoll. Läuft bei häufigen Änderungen höchstens alle 15 Minuten.',
      },
      critical_stock_notify: {
        name: 'Bestand kritisch → Hinweis an die Leitung',
        text: 'Sendet dem Team mit Bestandsberechtigung eine E-Mail, wenn eine Variante auf den kritischen Bestand fällt. Keine Wiederholung, solange sie darunter bleibt; erneuter Hinweis, wenn sie aufgefüllt wird und wieder fällt.',
      },
      restock_customers: {
        name: 'Wieder verfügbar → Kunden mit Einwilligung benachrichtigen',
        text: 'Kunden, die „Benachrichtigen, wenn verfügbar“ angefordert haben, erhalten eine E-Mail, sobald das Produkt wieder vorrätig ist (die Anfrage ist die Einwilligung; Sperrliste und Warteschlange gelten). Verwaltung im Bereich Bestands- und Preisbenachrichtigungen.',
      },
      paid_order_flow: {
        name: 'Bestellung bezahlt → Vorbereitung → Rechnung und Versand',
        text: 'Setzt eine bezahlte Bestellung auf „In Bearbeitung“ (der Bestand wurde bei der Bestellung reserviert), legt einen BizimHesap-Rechnungsentwurf an und sendet dem Team mit Versandberechtigung eine E-Mail zur Vorbereitung.',
      },
      cart_reminder: {
        name: 'Warenkorb verlassen → Einwilligungsprüfung → Erinnerung',
        text: 'Versand über den Ablauf „Verlassener Warenkorb“ in den Marketing-Automatisierungen: Marketing-Einwilligung, İYS, Sperrliste, Häufigkeitsgrenze und Ruhezeiten werden vor jeder E-Mail geprüft.',
      },
      approved_post_schedule: {
        name: 'Neuer Artikel freigegeben → Zeitgesteuerte Veröffentlichung',
        text: 'Plant einen von der Fachprüfung freigegebenen Artikel für 10:00 Uhr am Folgetag ein. Keine Veröffentlichung, wenn der Text nach der Freigabe geändert wurde (die Freigabe gilt dann nicht mehr).',
      },
      weekly_sales_report: {
        name: 'Woche abgeschlossen → Umsatzbericht → E-Mail',
        text: 'Erstellt jeden Montag um 08:00 Uhr den gespeicherten Bericht der Vorwoche mit den eigenen Berechtigungen jedes Empfängers; die E-Mail enthält nur einen Link zu „Meine Berichtsdateien“.',
      },
      tls_expiring_alert: {
        name: 'SSL-Ablauf naht → Sicherheitswarnung',
        text: 'Warnt die Shop-Manager, wenn das SSL-Zertifikat einer Domain weniger als 14 Tage gültig oder fehlerhaft ist; einmal pro Zertifikat.',
      },
      payment_hook_failure: {
        name: 'POS-Benachrichtigungsfehler → Kritische Warnung',
        text: 'Sendet Personen mit Berechtigung für Zahlungseinstellungen eine kritische Warnung, wenn eine Benachrichtigung (Webhook) oder Rückleitung eines Zahlungsanbieters abgelehnt wird oder nicht verarbeitet werden kann; höchstens einmal pro Stunde.',
      },
    },
    recentRuns: 'Letzte Läufe',
    runsTitle: 'Laufprotokoll',
    runsEmpty: 'Noch keine Läufe.',
    runColumns: { event: 'Ereignis', status: 'Status', progress: 'Aktion', when: 'Zeit' },
    runStatuses: {
      pending: 'Ausstehend',
      running: 'Läuft',
      succeeded: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
      skipped: 'Übersprungen',
      cancelled: 'Abgebrochen',
    },
    progress: '{{done}}/{{total}}',
    nextAttempt: 'Nächster Versuch: {{date}}',
    back: 'Automatisierungsabläufe',
    builderLegend: 'Ablaufdefinition',
    name: 'Name des Ablaufs',
    description: 'Beschreibung',
    runAs: 'Eingeschaltet von: {{name}} — Aktionen laufen mit den aktuellen Berechtigungen dieser Person.',
    activeEditNote:
      'Der Ablauf ist eingeschaltet: Ihre gespeicherte Änderung gilt für neue Ereignisse, und der Ablauf läuft ab jetzt in Ihrem Namen.',
    unsaved: 'Es gibt ungespeicherte Änderungen.',
    problemsTitle: 'Vor dem Einschalten beheben',
    problemAction: 'Aktion {{n}}',
    problemRule: 'Bedingung {{n}}',
    save: 'Speichern',
    saved: 'Ablauf gespeichert.',
    activate: 'Einschalten',
    activated: 'Der Ablauf ist eingeschaltet; Ereignisse ab jetzt werden verarbeitet.',
    pause: 'Anhalten',
    paused: 'Der Ablauf wurde angehalten.',
    archive: 'Archivieren',
    archiveConfirm:
      'Der Ablauf wird archiviert und kann nicht wieder eingeschaltet werden; das Laufprotokoll bleibt erhalten. Sind Sie sicher?',
    archived: 'Der Ablauf wurde archiviert.',
    step1: 'Auslöser',
    step2: 'Bedingungen',
    step3: 'Aktionen',
    trigger: 'Wann?',
    triggers: {
      product_created: 'Ein Produkt wurde angelegt',
      price_changed: 'Ein Preis wurde geändert',
      stock_critical: 'Bestand ist auf kritisches Niveau gefallen',
      payment_captured: 'Eine Bestellung wurde bezahlt',
      post_approved: 'Ein Artikel wurde fachlich freigegeben',
      schedule: 'Ein Zeitraum wurde abgeschlossen (Kalender)',
      tls_expiring: 'SSL-Zertifikat läuft bald ab',
      payment_webhook_failed: 'Zahlungsbenachrichtigung (POS) konnte nicht verarbeitet werden',
      integration_error: 'Ein Verbindungstest ist fehlgeschlagen',
    },
    triggerHints: {
      product_created:
        'Jedes neue Produkt, das in der Verwaltung, per Import oder durch Kopieren angelegt wird, ist ein Ereignis.',
      price_changed:
        'Eine einzelne Preisänderung, eine Massenpreisänderung (und ihre Rücknahme) und eine Wechselkursaktualisierung sind Ereignisse.',
      stock_critical:
        'Wie die Regeln für kritischen Bestand im Bestandsbericht: verkaufbare Menge auf oder unter dem Schwellenwert. Eine neu in die Liste aufgenommene Variante/ein neues Lager ist ein Ereignis; beim Einschalten bereits kritische zählen nicht.',
      payment_captured: 'Jede per Karte, POS oder „Zahlung erhalten“ vereinnahmte Zahlung ist ein Ereignis.',
      post_approved: 'Ein Ereignis, wenn ein Tierarzt/eine Fachperson einen Gesundheitsartikel freigibt.',
      schedule:
        'Läuft einmal am gewählten Tag zur gewählten Uhrzeit (Türkei) für den abgeschlossenen Zeitraum: gestern, letzte Woche (Montag–Sonntag) oder letzter Monat.',
      tls_expiring:
        'Eine Domain, deren Zertifikat laut Domainprüfung bald abläuft oder fehlerhaft ist; ein Ereignis pro Zertifikat.',
      payment_webhook_failed:
        'Ein Ereignis, wenn eine Benachrichtigung oder Rückleitung des Zahlungsanbieters abgelehnt wird (ungültige Signatur usw.) oder nicht verarbeitet werden kann.',
      integration_error: 'Ein Ereignis, wenn ein Verbindungstest in den Einstellungen fehlschlägt.',
    },
    frequencies: {
      daily: 'Täglich (gestern)',
      weekly: 'Wöchentlich (letzte Woche)',
      monthly: 'Monatlich (letzter Monat)',
    },
    weekdays: {
      '1': 'Montag',
      '2': 'Dienstag',
      '3': 'Mittwoch',
      '4': 'Donnerstag',
      '5': 'Freitag',
      '6': 'Samstag',
      '7': 'Sonntag',
    },
    noFields: 'Dieser Auslöser hat keine Bedingungsfelder; die Aktionen laufen bei jedem Ereignis.',
    noConditions: 'Keine Bedingungen: Die Aktionen laufen bei jedem Ereignis.',
    match: 'Bedingungen',
    matches: { all: 'Alle müssen zutreffen', any: 'Eine genügt' },
    addRule: 'Bedingung hinzufügen',
    ruleN: 'Bedingung {{n}}',
    removeRuleN: 'Bedingung {{n}} entfernen',
    ruleField: 'Feld',
    ruleOp: 'Vergleich',
    ruleValue: 'Wert',
    ruleValueMoney: 'Betrag (TRY)',
    ruleResult: { true: 'trifft zu', false: 'trifft nicht zu' },
    fields: {
      title: 'Name / Titel',
      status: 'Status',
      variantCount: 'Anzahl der Varianten',
      brand: 'Marke',
      source: 'Art der Änderung',
      priceList: 'Preisliste',
      sku: 'SKU',
      product: 'Produkt',
      available: 'Verkaufbare Menge',
      threshold: 'Schwellenwert',
      warehouse: 'Lager',
      scope: 'Art des Schwellenwerts',
      number: 'Bestellnummer',
      amount: 'Betrag',
      currency: 'Währung',
      provider: 'Anbieter',
      channel: 'Kanal',
      store: 'Shop',
      published: 'Freigegebene Fassung ist veröffentlicht',
      host: 'Domain',
      daysLeft: 'Verbleibende Tage',
      state: 'Zustand',
      kind: 'Benachrichtigungsart',
      outcome: 'Ergebnis',
      message: 'Meldung',
      environment: 'Umgebung',
    },
    options: {
      draft: 'Entwurf',
      active: 'Aktiv',
      archived: 'Archiviert',
      single: 'Einzelpreis',
      bulk: 'Massenänderung',
      revert: 'Massenänderung zurückgenommen',
      fx: 'Wechselkursaktualisierung',
      warehouse: 'Lager-Schwellenwert',
      variant: 'Varianten-Schwellenwert',
      default: 'Standard-Schwellenwert',
      web: 'Storefront',
      b2b: 'Händler',
      manual: 'Verwaltung',
      api: 'API',
      expiring: 'Läuft bald ab',
      error: 'Fehlerhaft',
      webhook: 'Benachrichtigung (Webhook)',
      callback: 'Rückleitung',
      rejected: 'Abgelehnt',
      sandbox: 'Test',
      live: 'Live',
      yes: 'Ja',
      no: 'Nein',
    },
    ops: {
      eq: 'ist gleich',
      neq: 'ist ungleich',
      gt: 'ist größer als',
      gte: 'ist mindestens',
      lt: 'ist kleiner als',
      lte: 'ist höchstens',
      contains: 'enthält',
      not_contains: 'enthält nicht',
      is_true: 'ja',
      is_false: 'nein',
    },
    actions: {
      notify_staff: 'E-Mail an das Team',
      seo_check: 'SEO-Prüfung',
      merchant_sync: 'Mit Merchant Center synchronisieren (Feed)',
      record: 'Änderungsprotokoll',
      order_processing: 'Bestellung auf „In Bearbeitung“ setzen',
      invoice_draft: 'Rechnungsentwurf (BizimHesap)',
      publish_post: 'Artikel veröffentlichen oder einplanen',
      send_report: 'Gespeicherten Bericht senden',
    },
    actionHints: {
      notify_staff:
        'Geht nur an Mitglieder der Verwaltung (das Team); an Kunden wird nichts gesendet. Die E-Mail enthält den Namen des Ablaufs, das Ereignis und einen Link zum Laufprotokoll.',
      seo_check:
        'Prüft das Produkt mit den Regeln des SEO-Kontrollzentrums (auch wenn es noch nicht veröffentlicht ist). Probleme werden im Schrittprotokoll aufgeführt.',
      merchant_sync:
        'Die Produkte des gewählten Shops werden an das Merchant Center gesendet (unveränderte nicht erneut). Ohne Google-Verbindung wird der Schritt mit „Einrichtung erforderlich“ übersprungen.',
      record: 'Schreibt das Ereignis und seine Felder als „Automatisierungseintrag“ ins Prüfprotokoll.',
      order_processing:
        'Nur eine Bestellung im Status „Bezahlt“ wird auf „In Bearbeitung“ gesetzt; hat das Team sie schon weitergesetzt, bleibt sie unverändert. Der Bestand wurde bei der Bestellung reserviert und wird beim Versand abgebucht.',
      invoice_draft:
        'Legt einen BizimHesap-Entwurf an, wenn die Bestellung keine Rechnung hat. Ist der Versand aktiv, entsteht eine e-Arşiv/e-Fatura; ein unklarer oder abgelehnter Versand wird nicht automatisch wiederholt.',
      publish_post:
        'Veröffentlicht den freigegebenen Artikel oder plant ihn für später ein. Keine Veröffentlichung, wenn der Text nach der Freigabe geändert wurde.',
      send_report:
        'Erstellt den gespeicherten Bericht für den Zeitraum mit den eigenen Berechtigungen jedes Empfängers und legt ihn unter „Meine Berichtsdateien“ ab; die E-Mail enthält keine Berichtsdaten.',
    },
    actionN: 'Aktion {{n}}',
    addAction: 'Aktion hinzufügen',
    moveUpN: 'Aktion {{n}} nach oben',
    moveDownN: 'Aktion {{n}} nach unten',
    removeActionN: 'Aktion {{n}} entfernen',
    notAllowed: '(keine Berechtigung)',
    incompatible: '(für diesen Auslöser nicht verfügbar)',
    choose: 'Auswählen',
    params: {
      days: 'Tage vor Ablauf',
      frequency: 'Häufigkeit',
      weekday: 'Tag',
      monthDay: 'Tag des Monats',
      hour: 'Uhrzeit (Türkei)',
      recipients: 'An',
      permission: 'Berechtigung',
      userIds: 'Personen',
      subject: 'E-Mail-Betreff',
      message: 'Nachricht (optional)',
      stopOnIssues: 'Bei SEO-Problemen nicht mit den nächsten Aktionen fortfahren',
      storeId: 'Shop',
      note: 'Protokollnotiz (optional)',
      send: 'Entwurf sofort an BizimHesap senden (erzeugt e-Arşiv/e-Fatura)',
      mode: 'Wann',
      hours: 'Stunden später',
      savedReportId: 'Gespeicherter Bericht',
      format: 'Dateiformat',
      recipientIds: 'Empfänger',
    },
    recipientsModes: { permission: 'Alle mit dieser Berechtigung', users: 'Von mir ausgewählte Personen' },
    placeholders: 'Im Text verwendbare Felder: {{list}}',
    publishModes: {
      now: 'Sofort',
      delay: 'Nach einigen Stunden',
      next_day: 'Am Folgetag zu einer festen Uhrzeit',
    },
    reportNone: 'Kein gespeicherter Bericht; speichern Sie zuerst einen Bericht im Berichtsgenerator.',
    advanced: 'Grenzen',
    throttle: 'Wartezeit nach einem Lauf (Minuten)',
    throttleNote:
      '0 = keine. Begrenzt Wiederholungen bei häufigen Ereignissen; in diesem Zeitfenster eingehende Ereignisse werden als „übersprungen“ protokolliert.',
    rate: 'Höchstzahl an Läufen pro Stunde',
    rateNote:
      'Bei Überschreitung hält sich der Ablauf selbst an, und die Leitung erhält eine E-Mail (Schutz vor Schleifen und Überflutung).',
    test: 'Mit letzten Ereignissen testen',
    testTitle: 'Testergebnis',
    testNote:
      'Die Bedingungen wurden mit den letzten Ereignissen des Auslösers geprüft; keine Aktion lief, nichts wurde geändert.',
    testEmpty: 'Für diesen Auslöser gibt es noch keine Ereignisse.',
    matched: 'Bedingungen treffen zu — Aktionen würden laufen',
    notMatched: 'Bedingungen treffen nicht zu — würde übersprungen',
    outOfScope: 'Außerhalb Ihrer Shop-Beschränkung — würde übersprungen',
    statusFilter: 'Status',
    runTitle: 'Lauf',
    triggerLabel: 'Auslöser',
    event: 'Ereignis',
    eventKey: 'Ereignisschlüssel',
    createdAt: 'Ereignis empfangen',
    finishedAt: 'Beendet',
    reasonLabel: 'Grund',
    lastError: 'Letzter Fehler',
    attempts: 'Wiederholung',
    fieldsTitle: 'Ereignisfelder',
    conditionsTitle: 'Bedingungen',
    stepsTitle: 'Schrittprotokoll',
    stepsEmpty: 'Noch keine Aktion gelaufen.',
    remaining: 'Nicht gelaufene Aktionen: {{list}}',
    outcomes: {
      succeeded: 'Erfolgreich',
      skipped: 'Übersprungen',
      stopped: 'Hat den Ablauf gestoppt',
      failed: 'Fehler',
    },
    attempt: '{{n}}. Versuch',
    reasons: {
      conditions_not_met: 'Die Bedingungen trafen nicht zu.',
      throttled: 'Vor Ende der Wartezeit eingegangen.',
      store_scope: 'Außerhalb der Shop-Beschränkung der einschaltenden Person.',
      workflow_paused: 'Der Ablauf wurde angehalten.',
      workflow_archived: 'Der Ablauf wurde archiviert.',
      manual: 'Manuell abgebrochen.',
      manual_retry: 'Manuell wiederholt.',
      stopped: 'Eine Aktion hat den Ablauf gestoppt',
    },
    codes: {
      not_configured: 'Einrichtung erforderlich: keine oder unvollständige Verbindung; Schritt übersprungen.',
      internal_error: 'Vorübergehender Fehler; wird wiederholt.',
      forbidden: 'Der einschaltenden Person fehlt dafür die Berechtigung.',
      unknown: 'Fehlercode: {{code}}',
    },
    detail: {
      issues: 'SEO-Probleme: {{list}}',
      recipients: 'An {{count}} Personen gesendet.',
      sent: 'An {{sent}} Empfänger gesendet, {{skipped}} übersprungen (keine Berechtigung oder Mitgliedschaft beendet).',
      publishAt: 'Veröffentlichungszeit: {{date}}',
      publishedNow: 'Sofort veröffentlicht.',
      merchant: 'Merchant Center: {{inserted}} gesendet, {{deleted}} gelöscht, {{unchanged}} unverändert.',
      orderStatus: 'Bestellstatus: {{status}}',
      invoice: 'Rechnung: {{status}}',
      permission: 'Benötigte Berechtigung: {{name}}',
    },
    invoiceStatuses: {
      draft: 'Entwurf angelegt',
      sending: 'wird gesendet',
      sent: 'gesendet',
      failed: 'konnte nicht gesendet werden',
      uncertain: 'Ergebnis unklar',
      cancelled: 'storniert',
    },
    retry: 'Wiederholen',
    retried: 'Der Lauf wurde erneut eingereiht; er setzt bei der Aktion fort, an der er stehen blieb.',
    cancel: 'Abbrechen',
    cancelConfirm: 'Der ausstehende Lauf wird abgebrochen, seine Aktionen laufen nicht.',
    cancelledToast: 'Der Lauf wurde abgebrochen.',
  },
};
